<template>
  <div
    v-if="visible"
    class="props-editor"
    :style="{
      left: offset.left + 'px',
      top: offset.top + 'px'
    }"
    v-click-outside="clickOutside"
  >
    <b-card v-if="form" class="props-editor__form">
      <b-form-group
        v-for="(item, propKey) in form"
        :key="propKey"
        :label="propKey"
        :disabled="inProgress"
      >
        <div v-if="form[propKey].type === 'Array'">
          <b-form-select
            :options="dataGrids"
            v-model="form[propKey].value"
            size="sm"
          />
        </div>
        <div v-else>
          <b-form-input v-model="form[propKey].value" size="sm" />
          <treeselect
            v-model="form[propKey].value"
            :multiple="false"
            :options="dataSourceList"
            :always-open="false"
            :searchable="true"
            :clearable="true"
            :defaultExpandLevel="2"
            :maxHeight="150"
          />
        </div>
      </b-form-group>
      <b-form-group>
        <b-button @click="save" variant="primary" size="sm" :disabled="inProgress">Save</b-button>
      </b-form-group>
    </b-card>
    <div class="props-editor__loading" v-else>
      <LoadingSpinner color="#bbb" size="30" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
// helpres
import eventBus from '@/helpers/event-bus'
// components
import LoadingSpinner from '@/components/LoadingSpinner'
// services
import db from '@/services/db'

export default {
  components: {
    LoadingSpinner,
  },
  data() {
    return {
      visible: false,
      name: null,
      offset: null,
      form: null,
      inProgress: false,
    }
  },
  computed: {
    ...mapState(['dataGrid_options', 'computedProps']),
    dataSourceList() {
      var list = []
      if (this.dataGrid_options) {
        for (let grid in this.dataGrid_options) {
          const id = `$getGrid('${grid}')`
          const label = 'List > ' + this.dataGrid_options[grid].title

          list.push({ id, label })
        }

        for (let grid in this.dataGrid_options) {
          var meta = this.dataGrid_options[grid].meta
          var gridtitle = this.dataGrid_options[grid].title

          Object.keys(meta).forEach(function(key) {
            const id = `$sum('${grid}', '${key}')`
            const label = '$ Sum ' + gridtitle + '.' + meta[key].displayName

            list.push({ id, label })
          })

          const id = `$sum('${grid}', '$count')`
          const label = '$ Count ' + gridtitle

          list.push({ id, label })
        }
      }
      if (this.computedProps) {
        for (let prop in this.computedProps) {
          const id = "$computed('" + prop + "')"
          const label = 'Computed > ' + prop

          list.push({ id, label })
        }
      }
      return list
    },
    dataGrids() {
      const options = [{ text: 'EMPTY', value: null }]

      if (!this.dataGrid_options) return options

      for (let dataGridKey in this.dataGrid_options) {
        const dataGrid = this.dataGrid_options[dataGridKey]

        options.push({
          text: dataGrid.title,
          value: `$getGrid('${dataGridKey}')`,
        })
      }

      return options
    },
  },
  methods: {
    clickOutside() {
      if (!this.visible) return

      this.visible = false
    },
    close() {
      this.visible = false
    },
    save() {
      try {
        let desc = _.cloneDeep(this.form)

        for (let propKey in desc) {
          if (desc[propKey].value === null) delete desc[propKey].value
        }

        desc = JSON.stringify(desc)
        this.inProgress = true

        db.components.savePropsDesc(this.name, desc).then(() => {
          this.inProgress = false
        })
      } catch (err) {
        console.error(err)
      }
    },
  },
  created() {
    eventBus.$on('propsEditorShow', async data => {
      let name
      let template
      let srcPropsName
      if (Array.isArray(data.name)) {
        name = data.name[0]
        template = data.name[1]
        srcPropsName = data.name[2]
      } else {
        name = data.name
      }

      this.name = name
      this.offset = null
      this.offset = data.offset

      setTimeout(() => {
        this.visible = true
      }, 100)

      let form = await new Promise(resolve => {
        db.components
          .getPropDesc(name)
          .then(desc => {
            resolve(desc)
          })
      })

      if (!form && template) {
        await new Promise(async resolve => {
          const srcProps = await new Promise(r => {
            db.root.ref('dashboards')
              .child(template)
              .child('widgetsData/componentProps')
              .child(srcPropsName)
              .once('value', snapshot => {
                r(snapshot.val())
              })
          })

          db.getRef('widgetsData/componentProps')
            .child(name)
            .set(srcProps)

          form = srcProps
          resolve()
        })
      }

      try {
        this.form = JSON.parse(form)
      } catch (err) {
        console.error(err)
      }
    })
  },
}
</script>

<style lang="scss">
.props-editor {
  position: absolute;
  left: 0;
  top: 0;
  width: 300px;
  z-index: 100100;
  &__loading {
    text-align: center;
    padding-top: 5px;
  }
  &__form {
    .card-body {
      padding: 10px 15px;
    }
    .form-group {
      margin-bottom: 10px;
    }
  }
}
* > .props-editor__edit-btn {
  display: none;
  position: absolute;
  right: 4px;
  top: 4px;
}
</style>
